import React from 'react';
import {Provider} from 'react-redux';
import ReactDOM from 'react-dom';
import ReactGA4 from 'react-ga4';
import ReactGA from 'react-ga';
import AppAdopta from './App/AppAdopta';
import configSentry from "./scripts/configSentry.js"

import '../public/vendors/bootstrap/v4.0.0/css/bootstrap.min.css';
import '../public/fonts/lineawesome/1.3.0/css/line-awesome.min.css';
import '../public/css/theme-adopta-map.min.css';
import '../public/vendors/select2/css/select2.min.css';
import '../public/css/vendors/imageRatioWithDragAndDrop/demohtml5imageupload.min.css';
import '../public/css/style-modal.min.css';
import '../public/css/vendors/react-s-alert1.3.2/s-alert-default.min.css';
import '../public/css/vendors/react-s-alert1.3.2/s-alert-css-effects/slide.min.css';
import '../public/css/vendors/react-datepicker-style.min.css';
import '../public/css/style.css'
import '../public/css/theme-adopta.css'
import '../public/css/theme-adopta-ads.css'
import '../public/css/theme-adopta-map.css'
import '../public/css/theme-adopta-card-infoRaza.css'
import '../public/css/style-banner-cmp-themoneytizer.css'

// console.log(JSON.stringify({NODE_ENV: process.env.NODE_ENV, DEV_ENV: process.env.DEV_ENV}));
if (process.env.NODE_ENV === 'production' && (process.env.DEV_ENV === 'DEMO' || process.env.DEV_ENV === 'PRO')) {
    // console.log('Iniciando Google Analytics -> '+process.env.GOOGLE_ANALYTICS_TAG_ID);
    if(process.env.GOOGLE_ANALYTICS_TAG_ID) ReactGA.initialize(process.env.GOOGLE_ANALYTICS_TAG_ID);
    // console.log('Iniciando Google Analytics 4 -> '+process.env.GOOGLE_ANALYTICS_4_TAG_ID);
    if(process.env.GOOGLE_ANALYTICS_4_TAG_ID) ReactGA4.initialize(process.env.GOOGLE_ANALYTICS_4_TAG_ID);
    
}

configSentry()

import configStore from './App/reducers';

const store = configStore().store
const persistor = configStore().persistor

ReactDOM.render(
    // <React.StrictMode>
        <Provider store={store}>
            <AppAdopta
                persistor={persistor}
                store={store}
            />
        </Provider>,
    // </React.StrictMode>,
    document.getElementById('root')
)


// setInterval(() => {
//   Alert.closeAll();
//   Alert.info(
//     'Ayudanos a mejorar la web 🙌🤲🙏 <br>Nos importa tu opinión!😊 <br><br> Unas preguntar rápidas, anónimas y sin compromiso 👻',
//     {
//       position: 'top-right',
//       effect: 'slide',
//       timeout: 'none',
//       customFields: {
//         messageItem: 5,
//         showIconClosed: true,
//         icon: 'las la-2x la-comment',
//       },
//     }
//   );
// }, 5 * 60 * 1000);
